<div class="card">
  <div class="card-body">
    <p class="mt-3">{{ card.MemberId }}</p>
    <!-- <fgb-mobile-pass [memberId]="card.MemberId"></fgb-mobile-pass> -->
  </div>
</div>
